<div class="projection-method-help">
  <strong class="projection-method-help__title">{{ option().hoverTitle }}</strong>
  <strong class="projection-method-help__heading">{{ option().hoverHeading }}</strong>
  <p class="projection-method-help__text">{{ option().hoverDescription }}</p>
</div>
